import React, { useState, useEffect } from 'react';
import { useApi } from '../../context/ApiProvider';
import { useNavigate, } from 'react-router-dom';
import { useLocale } from '../../localization/LocaleProvider';


export default function CloneTemplateForm({ clientId, organisationId, ...props }) {
  const [template, setTemplate] = useState(false); //Mall som ska klonas
  const [templates, setTemplates] = useState([]); //Mallar att välja från
  const [libraryTemplates, setLibraryTemplates] = useState([]); //Mallar från biblioteket
  const [uriType, setUriType] = useState(""); //Typ av mall [rolfing, development, pulse
  const [cloneSettings, setCloneSettings] = useState({ clientId: clientId, organisationId: organisationId });
  const [clients, setClients] = useState([]);
  const [organisations, setOrganisations] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null); //Vald mall som ska klonas (steg 1)
  const Api = useApi();
  const navigate = useNavigate();
  const { translate } = useLocale();
  const [session, setSession] = useState(false);

  useEffect(() => {
    Api.get("/clients").then(data => {
      setClients(data);
    });

    Api.getSession().then(session => {
      if (!session?.ID) {
        setSession(false);
        return;
      }

      Api.get(`/administrators/${session.ID}`).then(user => {
        setSession(user);
      })
    })
  }, [])

  useEffect(() => {
    if (!selectedTemplateId || !props.templates) return;

    if (!clientId || !organisationId || !uriType) return;

    const loadTemplate = () => {
      if (!selectedTemplateId) return;

      //Kolla om mallen som är vald finns bland biblioteksmallarna OCH är en Rolfing-mall, använd endpoint för library templates
      if (uriType == "rolfingtemplates" && libraryTemplates.find(temp => temp.ID == selectedTemplateId)) {
        return Api.get(`/library/rolfingtemplates/${selectedTemplateId}`).then(data => {
          setTemplate(data);
        }).catch(e => {
          console.log(e);
        });
      }

      //Annars, hämtas mallen från den vanliga endpointen
      Api.get(`/clients/${clientId}/organisations/${organisationId}/${uriType}/${selectedTemplateId}`).then(data => {
        setTemplate(data);
      }).catch(e => {
        console.log(e);
      })
    }

    loadTemplate();

  }, [selectedTemplateId]);


  useEffect(() => {
    props.template && setTemplate(props.template);

    if (props.type) {
      switch (props.type) {
        case "rolfing":
          setUriType("rolfingtemplates");
          break;
        case "development":
          setUriType("developmenttemplates");
          break;
        case "pulse":
          setUriType("pulsetemplates");
          break;
        default:
          setUriType("");
          break;
      }

      //Hämta mallar från biblioteket om det är en Rolfing-mall
      if (props.type == "rolfing" || props.type == "pulse") {
        const endpoint = props.type == "pulse" ? "/library/pulsetemplates" : "/library/rolfingtemplates";
        
        Api.get(endpoint).then(data => {
          setLibraryTemplates(data);
        }).catch(e => {
          console.log(e);
        });
      }
    }

    if (props.templates) {
      setTemplates(props.templates);
    }

  }, [props.template, props.type, props.templates]);

  useEffect(() => {
    async function loadOrganisations() {
      await Api.loadOrganisations(cloneSettings.clientId).then(data => {
        setOrganisations(data);
      }).catch(e => {
        console.log(e);
      });
    }
    loadOrganisations();
  }, [cloneSettings.clientId])

  /* Klona mallen */
  const cloneTemplate = async () => {
    if (!template) return;

    if (!cloneSettings.clientId || !cloneSettings.organisationId) {
      alert(translate("You need to select a client and organisation to clone the template to."));
      return;
    }

    try {
      const templateData = {
        name: `Copy of ${template.name}`,
        description: template.description,
        active: 0,
      }

      //Skapa ny mall
      let response = await Api.post(`/clients/${cloneSettings.clientId}/organisations/${cloneSettings.organisationId}/${uriType}`, templateData);

      templateData.actionsDescription = template.actionsDescription;
      templateData.feedbackDescription = template.feedbackDescription;

      if (props.type == "rolfing" || props.type == "pulse") {
        templateData.rolfingScale = template.rolfingScale;
      } else if (props.type == "development") {
        templateData.developmentScale = template.developmentScale;
      }


      templateData.scaleLabels = template.scaleLabels ? [...template.scaleLabels] : [];
      templateData.organisation = { ...template.organisation };
      templateData.properties = template.properties.map((property) => {
        return {
          name: property.name,
          description: property.description,
          sortOrder: property.sortOrder,
          removeStep: false,
          customPlaceholders: property.customPlaceholders,
          scaleLabels: property.scaleLabels ? [...property.scaleLabels] : null,
        }
      });


      //Uppdatera den nya mallen med data från den gamla
      Api.put(`/clients/${cloneSettings.clientId}/organisations/${cloneSettings.organisationId}/${uriType}/${response.ID}`, templateData).then(() => {
        //Navigera till den nya mallen
        //Url på puls skiljer sig lite från övriga mallar
        let url = uriType == "pulsetemplates" ? `/clients/${cloneSettings.clientId}/organisations/${cloneSettings.organisationId}/pulses/pulsesurveytemplates/${response.ID}` : `/clients/${cloneSettings.clientId}/organisations/${cloneSettings.organisationId}/${uriType}/${response.ID}`;

        navigate(url, {
          state: { successMessage: translate("Template cloned successfully."), closeModal: true }
        });

      });
    } catch (e) {
      console.log(e);
      alert("Error: Unable to clone the template.");
    }
  }

  const handleCloneToLibrary = async () => {
    if (!template) return;

    if (!session || !session.rolf || session.rolf != 1) {
      alert(translate("You need to be a Rolf administrator to clone templates to the template library."));
      return;
    }

    if(!window.confirm(translate("Are you sure you want to clone this template to the template library?"))) {
      return;
    }

    const templateData = {
      name: `${template.name}`, //Lagrar originalnamnet i biblioteket
      description: template.description, 
      pulseTemplate: template.pulseTemplate ? 1 : 0,
      active: 0, //Inaktiv som standard, måste aktiveras efter kloning till kund
    }

    //pulsetemplates om pulsmall annars rolfingtemplates
    let endpoint = template.pulseTemplate ? `/library/pulsetemplates` : `/library/rolfingtemplates`;

    //Skapa ny mall
    let response = await Api.post(endpoint, templateData);

    if (!response || !response.ID) {
      alert(translate("Error: Unable to clone the template to the library."));
      return;
    } 

    templateData.actionsDescription = template.actionsDescription;
    templateData.feedbackDescription = template.feedbackDescription;
    templateData.rolfingScale = template.rolfingScale; //För evt. utvecklingsplansmallar i framtiden skall detta vara: templateData.developmentScale = template.developmentScale;
    templateData.pulseTemplate = template.pulseTemplate ? 1 : 0;
    templateData.scaleLabels = template.scaleLabels ? [...template.scaleLabels] : [];
    templateData.organisation = { ...template.organisation };

    templateData.properties = template.properties.map((property) => {
      return {
        name: property.name,
        description: property.description,
        sortOrder: property.sortOrder,
        removeStep: false,
        customPlaceholders: property.customPlaceholders,
        scaleLabels: property.scaleLabels ? [...property.scaleLabels] : null,
      }
    });

    //Uppdatera den nya mallen med data från den gamla

    Api.put(`/library/rolfingtemplates/${response.ID}`, templateData).then(() => {
      alert(translate("Template cloned to the template library successfully.")); //Navigerar INTE till den nya mallen, skriver ut alert om att kloningen till biblioteket lyckades
    });
  }


  if (!template) return (
    <div>
      <h4>{translate("Select template to clone")}</h4>
      <p>{translate("First, select a template to clone. In the next step you will select which client and organisation to clone the template to.")}</p>
      <p>{translate("The list below shows all")} <strong>{translate(props.type)}</strong>{translate("templates in the current organisation.")}</p>
      <label htmlFor="selectTemplate">{translate("Template")}</label>
      <select id="selectTemplate" className='formControl' onChange={(event) => setSelectedTemplateId(event.target.value)}>
        {/*props.type && (props.type == "rolfing" || props.type == "pulse") ? <>
          <optgroup label={translate("Templates in current organisation")}>
            <option>{translate("Select template")}</option>
            {
              templates && templates.map((template, index) => {
                return <option key={`template_${index}`} value={template.ID}>{template.name}</option>
              })
            }
          </optgroup>
          <optgroup label={translate("Templates from template library")}>
            {
              libraryTemplates && libraryTemplates.map((template, index) => {
                return <option key={`library_template_${index}`} value={template.ID}>{template.name}</option>
              })
            }
          </optgroup> </> : */
          <>
            <option>{translate("Select template")}</option>
            {
              templates && templates.map((template, index) => {
                return <option key={`template_${index}`} value={template.ID}>{template.name}</option>
              })
            }

          </>
        }
      </select>
    </div>
  )

  return (
    <div>
      <p>{translate("Select which client and organisation you want to clone this template to. You can clone templates into all clients and organisations which you, as administrator, has access to.")}</p>
      <label htmlFor="selectedTemplate">{translate("Template")}</label>
      <div className="spaceBetween" id="selectedTemplate"><span>{template.name}</span>{!props.template && <a onClick={() => setTemplate(false)}>{translate("Change template")}</a>}</div>

      <label htmlFor="selectClient">{translate("Client")}</label>
      <select id="selectClient" onChange={(event) => setCloneSettings({ ...cloneSettings, clientId: event.target.value, organisationId: null })} className='formControl'>

        <option value={clientId}>{translate("Current client")}</option>
        {
          clients && clients.map((client, index) => {
            return <option key={index} value={client.ID}>{client.name}</option>
          })
        }
      </select>
      <label htmlFor="selectOrganisation">{translate("Organisation")}</label>
      <select id="selectOrganisation" onChange={(event) => setCloneSettings({ ...cloneSettings, organisationId: event.target.value })} className='formControl'>
        {cloneSettings.clientId == clientId ? <option value={organisationId}>{translate("Current organisation")}</option> : <option value={null}>{translate("Select organisation")}</option>}
        {
          organisations && organisations.map((organisation, index) => {
            return <option key={index} value={organisation.ID}>{organisation.name}</option>
          })
        }
      </select>
       <div className='flex spaceBetween'>
        <button onClick={() => cloneTemplate()}>{translate("Clone template")}</button>
        { session.rolf == 1 && !props.disableCloneToLibrary && <button onClick={() => handleCloneToLibrary()}><i className="fa fa-unlock-alt" aria-hidden="true"></i> {translate("Clone to template library")}</button> }
      </div>
    </div>
  )
}